import { parsePhoneNumberFromString } from "libphonenumber-js";

export function isValidIntlPhone(value: string): boolean {
  if (!value) return false;

  const trimmed = value.trim();
  if (!trimmed.startsWith("+")) return false; 

  try {
    const phoneNumber = parsePhoneNumberFromString(trimmed);
    return !!phoneNumber && phoneNumber.isValid();
  } catch {
    return false;
  }
}
